import React from 'react';
import { FaHome } from 'react-icons/fa';

import { Container, GifDiv } from './styles';
import Button from '../../components/Button';

interface IProps {
  error?: string;
}

export default function ErrorPage({ error }: IProps) {
  return (
    <Container>
      <h1>{error ? 'Falha ao carregar' : '404'}</h1>
      <GifDiv />
      <h2>{error ? error : 'Parece que você está perdido'}</h2>
      <span>
        {error ?
          'Verifique sua conexão com a internet. Caso o problema persista, entre em contato com o responsável técnico.'
          : 'A página que está procurando não está disponível, verifique a URL digitada.'
        }
      </span>
      {!error && <a href='/'>
        <Button texto='Página inicial' icone={<FaHome />} tabIndex={-1} />
      </a>}
    </Container>
  );
}
